// SkeletonLoading component

import React from 'react';

const SkeletonLoading = () => {
  return (
    <div className="animate-pulse space-y-4">
      {/* Create multiple divs to represent skeleton loading */}
      {/* <div className="h-4 bg-gray-300 rounded w-3/4"></div>
      <div className="h-4 bg-gray-300 rounded w-1/2"></div>
      <div className="h-4 bg-gray-300 rounded w-5/6"></div>
      <div className="h-4 bg-gray-300 rounded w-3/4"></div>
      <div className="h-4 bg-gray-300 rounded w-4/5"></div> */}
      <div className="flex justify-center items-center h-full">
                        <div className="flex flex-col items-center">
                            <div className="loader border-t-4 border-primary w-12 h-12 rounded-full animate-spin"></div>
                            <p className="mt-4 text-gray-600">Loading...</p>
                        </div>
                    </div>
    </div>
  );
};

export default SkeletonLoading;
